export default {"src":"/_next/static/media/pin.889c674a.svg","height":22,"width":18,"blurWidth":0,"blurHeight":0};